import { ApiEndpointSelect } from 'features/dev-tools'

export const Dev = () => {
	return (
		<div>
			<ApiEndpointSelect />
		</div>
	)
}
